<template>
  <div class="category-selector">
    <button
      class="category-selector__item"
      :class="{ active: key === value }"
      v-for="(count, key) of categories"
      :key="key"
      @click="$emit('input', key)"
    >
      <ui-icon :name="key" />
      <span>{{ key }}</span>
      <span class="category-selector__count">{{ getCount(count) }}</span>
    </button>

    <button
      v-if="value === 'trash' && categories.trash > 0"
      class="btn btn-sm btn-danger"
      v-confirm="{
        ok: cleanCallback,
        message: 'Are you sure you want to empty your trash?'
      }"
    >
      Empty Trash
    </button>
  </div>
</template>

<script>
import API from '../../../../api'
import UiIcon from '../../ui-kit/ui-icon.vue'
export default {
  components: { UiIcon },
  name: 'category-selector',
  props: {
    categories: Object,
    value: [String, null]
  },
  computed: {
    endpointId() {
      return this.$store.getters.endpointId
    },
    currentProject() {
      return this.$store.getters.currentProject || {}
    }
  },
  methods: {
    getCount(count) {
      const total = count[0] || 0
      const unread = count[1] || 0
      return `${unread}/${total}`
    },
    async cleanCallback() {
      await API.messages.cleanTrash({
        projectId: this.currentProject.id,
        endpointId: this.endpointId
      })
      this.$emit('update')
    }
  }
}
</script>

<style lang="scss" scoped>
.category-selector {
  display: flex;
  flex-wrap: wrap;
  &__item {
    display: flex;
    align-items: center;
    height: calc(1.5em + 1rem + 2px);
    margin-right: 0.5rem;
    padding: 0;
    padding-left: 0.5rem;
    font-size: 0.875rem;
    background: $gray-400;
    border: 0;
    border-radius: $border-radius;
    outline: none;
    transition: 0.2s;
    &.active {
      color: $white;
      background: $primary;
    }
    & > * {
      margin-right: 0.5rem;
      &:last-child {
        margin-right: 0;
      }
    }
    span {
      font-size: 12px;
      text-transform: uppercase;
    }
    svg {
      display: inline-block;
      width: 1.5em;
    }
  }
  &__count {
    padding: 0.5rem;
    border-left: 1px solid rgba($white, 0.4);
  }
}
</style>
